/* global smartlook */

const confirmPermissions = () => {
  smartlook('record', { forms: true, emails: true, ips: true, numbers: true });
};

const initAnalytics = ({ userId, merchantId, platformCartId, storeUrl }) => {
  // TODO: remove conditions once we decide which one will be used in production
  if (process.env.REACT_APP_ANALYTICS_TOOL === 'fullstory') {
    /* global FS */
    FS.identify(userId, {
      merchantId,
      platformCartId,
      storeUrl,
    });
  } else if (process.env.REACT_APP_ANALYTICS_TOOL === 'smartlook') {
    smartlook('identify', userId, {
      merchantId,
      platformCartId,
      storeUrl,
    });
  }
};

const smartLookEvent = (event, properties) => smartlook('track', event, properties);

const identifyUserNameEmail = ({ userId, shippingName }) => {
  smartlook('identify', userId, {
    name: shippingName,
  });
};

export { confirmPermissions, initAnalytics, identifyUserNameEmail, smartLookEvent };
